import { useEffect } from "react";

type RefMap = { [key: string]: HTMLDivElement | null };
type SetterMap = React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;

const useClickOutsideMap = (
  refMap: React.MutableRefObject<RefMap>,
  setStateMap: SetterMap,
  skipRef?: React.RefObject<HTMLElement>
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      // Ignore clicks inside the modal
      if (skipRef?.current && skipRef.current.contains(target)) {
        return;
      }
      Object.entries(refMap.current).forEach(([key, ref]) => {
        if (ref && !ref.contains(target)) {
          setStateMap((prev) => ({ ...prev, [key]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [refMap, setStateMap, skipRef]);
};

export default useClickOutsideMap;
